import { Category, ProductsService } from '../api';

interface CategoryProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Category[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Category }>;
  getOne: (resource: string, params: any) => Promise<{ data: Category }>;
  update: (resource: string, params: any) => Promise<{ data: Category }>;
  getMany: (resource: string, params: any) => Promise<{ data: Category[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Category[] }>;
}

export const categoryProvider: CategoryProviderResource = {
  getList: async (resource, paramms) => {
    const { items } = await ProductsService.categoriesList();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const category = await ProductsService.categoryAdd(params.data);
    return { data: category };
  },
  getOne: async (resource, params) => {
    const category = await ProductsService.getCategory(params.id);
    return { data: category };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { name },
    } = params;
    const category = await ProductsService.updateCategory(params.id, {
      name,
    });
    return { data: category };
  },
  getMany: async (resource, params) => {
    console.log(resource);
    console.log(params);
    const ids = params.ids;
    console.log(ids);
    const data: Category[] = [];
    for (const id of ids) {
      const model = await ProductsService.getCategory(id);
      data.push(model);
    }
    return { data: data };
  },
  getManyReference: async (resource, params) => {
    console.log(resource);
    console.log(params);
    return { data: [] };
  },
};
